"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistrictByLabel = getDistrictByLabel;
const constants_1 = require("../constants");
// Looks up and returns the district object based on the 'label' value
function getDistrictByLabel(label) {
    return Object.values(constants_1.DISTRICTS).find((district) => district.label === label);
}
